import { ITopProductProps } from '../../../../topProduct.models';
import * as S from './topNavigationLiteHero.style';
import { DetailsChecklist } from '../DetailsChecklist/detailsChecklist';
import { CustomText, ImageAtoms, Price, Svg } from '@vfit/shared/atoms';
import { IGradientImage, PriceVariant } from '@vfit/shared/models';
import ProductOptions from '../../../../../ProductCardLite/components/ProductOptions/productOptions';
import { useState } from 'react';
import { VfModal } from '@vfit/shared/components';
import { purify } from '@vfit/shared/themes';

export const TopNavigationLiteHero = ({ product }: ITopProductProps) => {
  const {
    title,
    price,
    priceLiteLabel,
    originalPrice,
    recurrence,
    description,
    image,
    imageMobile,
    backLabel,
    backUrl,
    inflactionPdp,
    inflactionHub,
    isGlobalPromoActive,
    priceVariant,
    pdpLiteOptionDetails,
    pdpLiteCtaPopup,
    pdpLitePopupDescription,
    pdpLitePopupTitle,
    pdpLiteMarketingTagLabel: marketingTagLabel,
    pdpLiteMarketingTagColor: marketingTagColor,
    pdpLiteMarketingTagBackground: marketingTagBg,
    pdpLiteMarketingTagSecondaryLabel: secondaryMarketingTagLabel,
    pdpLiteMarketingTagSecondaryColor: secondaryMarketingTagColor,
    pdpLiteMarketingTagSecondaryBackground: secondaryMarketingTagBg,
  } = product;
  const [pDescription] = purify([description || '']);
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  return (
    <S.BannerContainer>
      <S.DivImgContainer>
        <ImageAtoms
          gradient={IGradientImage.GRADIENT_TOP_LEFT}
          nameCard="slideProduct"
          image={image}
          imageMobile={imageMobile}
        />
      </S.DivImgContainer>
      <S.MainSection>
        <S.Breadcrumb>
          <Svg name={'chevronLeft'} width={16} height={16} color={'#fff'} />
          <S.GoBackLabel onClick={() => window.location.href = backUrl || ''}>{backLabel}</S.GoBackLabel>
        </S.Breadcrumb>
        <S.OfferSection>
          <S.TagContainer>
            {marketingTagLabel && (
              <S.Tag bgColor={marketingTagBg} color={marketingTagColor}>
                <span>{marketingTagLabel}</span>
              </S.Tag>
            )}
            {secondaryMarketingTagLabel && (
              <S.Tag bgColor={secondaryMarketingTagBg} color={secondaryMarketingTagColor}>
                <span>{secondaryMarketingTagLabel}</span>
              </S.Tag>
            )}
          </S.TagContainer>
          <S.TitleContainer>
            <S.Title>{title}</S.Title>
            {pdpLiteCtaPopup && (
              <S.SubtitleCta onClick={() => setIsOpenPopup(true)}>{pdpLiteCtaPopup}</S.SubtitleCta>
            )}
          </S.TitleContainer>
        </S.OfferSection>
      </S.MainSection>

      <S.CardDetails>
        <S.OfferDetails>
          <div>
            <Price
              label={priceLiteLabel || ''}
              amount={price}
              oldAmount={originalPrice}
              recurrence={recurrence}
              variant={product?.isLandingClub ? 'freeAmount' : (priceVariant as PriceVariant)}
              detail={product?.isLandingClub ? product?.subprice : ''}
              description={product?.isLandingClub ? product?.descriptionRecurring : ''}
            />
            {pDescription && (
              <div
                className="productDescription"
                dangerouslySetInnerHTML={{ __html: pDescription }}
              />
            )}
          </div>
          <div>
            <ProductOptions
              isShoppingCart={false}
              isGlobalPromoActive={isGlobalPromoActive}
              inflactionCartView={inflactionPdp}
              inflactionHub={inflactionHub}
            />
          </div>
          {pdpLiteOptionDetails && (
            <S.DetailsList>
              <DetailsChecklist checkList={pdpLiteOptionDetails} />
            </S.DetailsList>
          )}
        </S.OfferDetails>
      </S.CardDetails>
      <VfModal isOpen={isOpenPopup} handleClose={() => setIsOpenPopup(false)}>
        <>
          <S.ModalTitle>
            <CustomText size={36} lineHeight={45} text={pdpLitePopupTitle || ''} />
          </S.ModalTitle>

          <S.ModalContent>
            <CustomText
              size={18}
              lineHeight={24}
              textAlign="left"
              text={pdpLitePopupDescription || ''}
            />
          </S.ModalContent>
        </>
      </VfModal>
    </S.BannerContainer>
  );
};
